/* tslint:disable */
/* eslint-disable */
/**
 * IGA Gewinnspiel API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@wapp.gmbh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadInfo
 */
export interface UploadInfo {
    /**
     * 
     * @type {string}
     * @memberof UploadInfo
     */
    fileRef: string;
    /**
     * 
     * @type {string}
     * @memberof UploadInfo
     */
    uploadUrl: string;
}

export function UploadInfoFromJSON(json: any): UploadInfo {
    return UploadInfoFromJSONTyped(json, false);
}

export function UploadInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileRef': json['fileRef'],
        'uploadUrl': json['uploadUrl'],
    };
}

export function UploadInfoToJSON(value?: UploadInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileRef': value.fileRef,
        'uploadUrl': value.uploadUrl,
    };
}


